import React from 'react'

import './button-close.scss'

export const ButtonClose = ({ onClick }) => {
  return (
    <button className="btnClose" onClick={onClick}>
      <span className="icon-cross"></span>
    </button>
  )
}
